import {
    PageContainer,
    Text
} from "ncore-ui-kit";

const ThreeT = () => {
    return <PageContainer>
        <Text>
            Welcome to Common/ThreeT Page
        </Text>
    </PageContainer>;
};
export default ThreeT;
